<template>
  <!--
      作者：gmshop
      时间：2019-10-25
      描述：订单详情
  -->
  <div class="pb50" v-loading="loading">
    <!--内容-->
    <div class="product-content">
      <!--基本信息-->
      <div class="common-form">基本信息</div>
      <div class="table-wrap">
        <el-row>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">期数：</span>
              {{ detail.draw_date }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">用户信息：</span>
              {{ detail.user.nickName }}
              <br><span>用户ID：({{ detail.user.user_id }})</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">抽奖码：</span>
              {{ detail.lottery_code }}

            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">类型：</span>
              <span v-if="detail.type == 10">月抽奖</span>
              <span v-if="detail.type == 20">复活奖</span>
              <span v-if="detail.type == 30">豪华奖</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <div class="pb16">
            <span class="gray9">参与时间：</span>
            {{ detail.add_time }}
          </div>
        </el-row>
        <el-row>
          <div class="pb16">
            <span class="gray9">中奖时间：</span>
            {{ detail.create_time }}
          </div>
        </el-row>
        <div v-if="detail.is_accept == 20">
        <el-row>
          <div class="pb16">
            <span class="gray9">领奖时间：</span>
            {{ detail.accept_time }}
          </div>
        </el-row>
        </div>
        <div v-else="">
        <el-row>
          <div class="pb16">
            <span class="gray9">未领奖</span>

          </div>
        </el-row>
        <el-row>
          <div class="pb16">
            <span class="gray9">截止领奖时间：</span>
            {{ detail.no_accept_time }}
          </div>
        </el-row>
        </div>

      </div>


      <!--商品信息-->
      <div class="common-form mt16">奖品信息</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">奖品名称：</span>
                {{ detail.prize.prize_name }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">奖品图片：</span>

                   <div class="product-info">
                     <div class="pic"><img v-img-url="detail.prize.image[0].file_path" /></div>

                   </div>

              </div>
            </el-col>


          </el-row>

        </div>

      <!--收货信息-->
      <div v-if="detail.address != ''">
        <div class="common-form mt16">收货信息</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">收货人：</span>
                {{ detail.address.name }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">收货电话：</span>
                {{ detail.address.phone }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">收货地址：</span>
                {{ detail.address.region.province }} {{ detail.address.region.city }} {{ detail.address.region.region }} {{ detail.address.detail }}
              </div>
            </el-col>
          </el-row>

        </div>
      </div>


      <!--发货信息-->
      <div>
        <div v-if="detail.delivery_status == 10">
          <!-- 去发货 -->
          <div class="common-form mt16">去发货</div>
          <el-form size="small" ref="form" :model="form" label-width="100px">
            <el-form-item label="物流公司">
              <el-select v-model="form.express_id" placeholder="请选择快递公司">
                <el-option :label="item.express_name" v-for="(item, index) in expressList" :key="index" :value="item.express_id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="物流单号">
              <el-input v-model="form.express_no" class="max-w460"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-else="">
          <div class="common-form mt16">发货信息</div>
          <div class="table-wrap">
            <el-row>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">物流公司：</span>
                  {{ detail.express_name }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">物流单号：</span>
                  {{ detail.express_no }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">发货状态：</span>
                  <span v-if="detail.delivery_status == 20">已发货</span>

                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">发货时间：</span>
                  {{ detail.delivery_time }}
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      </div>
    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="cancelFunc">返回上一页</el-button>
      <!--确认发货-->
      <template>
        <el-button size="small" type="primary" @click="onSubmit" v-if="detail.delivery_status == 10">确认发货</el-button>
      </template>

    </div>
  </div>
</template>

<script>
  import OrderApi from '@/api/lottery.js';

  import {
    deepClone
  } from '@/utils/base.js';
  export default {
    components: {

    },
    data() {
      return {
        active: 0,
        /*是否加载完成*/
        loading: true,
        /*订单数据*/
        detail: {
          pay_status: [],
          pay_type: [],
          delivery_type: [],
          user: {},
          address: [],
          product: [],
          order_status: [],
          extract: [],
          extract_store: [],
          express: [],
          delivery_status: [],
          extractClerk: []
        },
        /*是否打开添加弹窗*/
        open_add: false,
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*发货*/
        form: {
          /*订单ID*/
          express_id: null,
          /*订单号*/
          express_no: ''
        },
        forms: {
          is_cancel: 1
        },
        extract_form: {
          order: {
            extract_status: 1
          }
        },
        order: {},
        delivery_type: 0,
        /*配送方式*/
        exStyle: [],
        /*门店列表*/
        shopList: [],
        /*当前编辑的对象*/
        userModel: {},
        /*时间*/
        create_time: '',
        /*快递公司列表*/
        expressList: [],

        /*是否打开编辑弹窗*/
        open_edit: false
      };
    },
    created() {
      /*获取列表*/
      this.getParams();
    },
    methods: {
      next() {
        if (this.active++ > 4) this.active = 0;
      },
      /*获取参数*/
      getParams() {
        let self = this;
        // 取到路由带过来的参数
        const params = this.$route.query.win_id;
        OrderApi.winlotterydetail({
              win_id: params
            },
            true
          )
          .then(data => {
            self.loading = false;
            self.detail = data.data.detail;
            self.expressList = data.data.expressList;

          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*发货*/
      onSubmit() {
        let self = this;
        let param = self.form;
        if (param.express_id == null) {
          this.$message.error('请选择物流公司');
          return;
        }
        if (param.express_no == '') {
          this.$message.error('请填写物流单号');
          return;
        }

        let win_id = this.$route.query.win_id;
        OrderApi.delivery({
              param: param,
              win_id: win_id
            },
            true
          )
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，发货成功',
              type: 'success'
            });
            self.getParams();
          })
          .catch(error => {
            self.loading = false;
          });
      },



      /*打开编辑*/
      editClick(item) {
        this.userModel = deepClone(item);
        this.open_edit = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          this.getParams();
        }
      },

      /*取消*/
      cancelFunc() {
        /*存储缓存*/
        localStorage.setItem('activeName','accept')
        this.$router.push({
          path: '/plus/lottery/index',
          query: {
            active: 'accept',

          }
        });
      }

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/plus/lottery/accept/detail.vue